<template>
    <div class="container mt-3">
        <div class="row">
            <div class="col-4">
                <div class="form-group">
                    <label for="place">Seleccionar recinto</label>
                    <multiselect
                        v-model="place"
                        placeholder="Seleccionar recinto"
                        label="name"
                        track-by="id"
                        :options="places"
                        :multiple="false"
                    ></multiselect>
                </div>
            </div>
            <div class="col-8 mb-2" v-if="!loading_zonas && place">                
                <CleSvgComponent
                    v-if="zonas.length > 0"
                    :zonas="zonas"
                    :place="place"
                    @clickZona="irAZona"
                />
                <TablaSectoresComponent
                    class="mt-2"
                    v-if="zonas.length > 0"
                    :zonas="zonas"
                    @goTo="selectZonaTable"
                />
            </div>
            <div v-if="loading_zonas" class="col-8 text-center" style="height: 150px">
                <LoaderComponent></LoaderComponent>
            </div>
        </div>
        <template v-if="zona">
            <div class="row">
                <div class="col-12">
                    <h1>Ocultar butacas</h1>
                </div>
                <div class="col-12">
                    <TerrenoJuegoComponent :direccion_campo="zona.direccion_campo"/>

                    <div class="container-butacas-wrapper hidden-seats" v-if="!loading_butacas">
                        <div :class="'container-butacas text-align-' + zona.print_align">
                            <template v-for="(butacas, fila) in filas">
                    <span :key="fila">
                        <span class="fila">{{ fila }}</span>
                        <template v-for="(asiento, index) in butacas">
                            <AsientoComponent :asiento="asiento" :fila="fila" :key="index+'_2'" @toggle="() => toggleSeleccion(fila, asiento.asiento, true, true)"/>
                        </template>

                        <br />
                    </span>
                            </template>
                        </div>
                    </div>
                    <div v-else>
                        <LoaderComponent></LoaderComponent>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-1" style="background-color: #d2d3d4;"></div>
                <div class="col-11 justify-content-center">
                    <span>Butaca oculta (No se muestra la butaca ni se respeta el hueco)</span>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-1" style="background-color: #343deb;"></div>
                <div class="col-11 justify-content-center">
                    <span>Pasillo: No se muestra la butaca, pero se respeta su hueco (Siguiendo con la numeración)</span>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-1" style="background-color: #b30202;"></div>
                <div class="col-11 justify-content-center">
                    <span>Passillo: No se muestra la butaca, pero se respeta su hueco (Saltando la numeración)</span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <button class="mr-3" :class="{ 'btn-success': mode == 1, 'btn-light': mode != 1 }" @click="cambiarModo(1)">Ocultar butacas</button>
                    <button class="mr-3" :class="{ 'btn-success': mode == 2, 'btn-light': mode != 2 }" @click="cambiarModo(2)">Añadir pasillo (Siguiendo con la numeración)</button>
                    <button :class="{ 'btn-success': mode ==3, 'btn-light': mode != 3 }" @click="cambiarModo(3)">Añadir pasillo (Saltando la numeración)</button>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <h1>Resultado</h1>
                </div>
                <div class="col-12">
                    <button class="btn" @click="getZonaResultado(zona.id)">Actualizar</button>
                </div>
                <div class="col-12">
                    <TerrenoJuegoComponent :direccion_campo="zona.direccion_campo"/>
                    
                    <div class="container-butacas-wrapper" v-if="!loading_resultado">
                        <div :class="'container-butacas text-align-' + zona.print_align">
                            <template v-for="(butacas, fila) in filas_resultado">
                                <span :key="fila">
                                <span class="fila">{{ fila }}</span>
                                <template v-for="(asiento, index) in butacas">
                                    <AsientoComponent :asiento="asiento" :fila="fila" :key="index+'_2'" @toggle="() => toggleSeleccion(fila, asiento.asiento, true, true)"/>
                                </template>

                                <br />
                                </span>
                            </template>
                        </div>
                    </div>
                    <div v-else>
                        <LoaderComponent></LoaderComponent>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h1>Listado de butacas ocultas</h1>
                </div>
                <div class="col-12">
                    <ul class="list-group">
                        <template v-for="oculto in zona.ocultos">
                            <li :key="oculto.id" class="list-group-item">
                                <b>Fila:</b> {{ oculto.row }} /
                                <b>Asiento:</b> {{ oculto.seat }} /
                                <b>Modo:</b>
                                <div class="mx-3" v-if="oculto.mode == 1" style="background-color: #d2d3d4; width: 30px; height: 30px; display: inline-block"></div>
                                <div class="mx-3" v-if="oculto.mode == 2" style="background-color: #343deb; width: 30px; height: 30px; display: inline-block"></div>
                                <div class="mx-3" v-if="oculto.mode == 3" style="background-color: #b30202; width: 30px; height: 30px; display: inline-block"></div>
                                <button class="btn" @click="toggleSeleccion(oculto.row, oculto.seat)">Borrar</button>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import CleSvgComponent from '@/components/backend/stepper/components/CleSvgComponent';
import AsientoComponent from "../../../components/backend/stepper/components/AsientoComponent";
import TerrenoJuegoComponent from '../../../components/common/Asientos/TerrenoJuegoComponent.vue';
import TablaSectoresComponent from '@/components/backend/stepper/components/TablaSectoresComponent.vue';

export default {
    data() {
        return {
            places: [],
            place: null,
            zonas: [],
            loading_zonas: false,
            loading_butacas: false,
            zona: null,
            filas: [],
            filas_resultado: [],
            seats: [],
            mode: 1,
            loading_resultado: false
        }
    },
    created() {
        this.getPlaces();
    },
    watch: {
        place() {
            this.getZonas(this.place.id);
        }
    },
    methods: {
        cambiarModo(modo) {
            this.mode = modo;
        },
        getPlaces() {
            this.$store.dispatch(this.config.getVuexAlias('recintos.index')).then(res => {
                this.places = res.data.data;
            });
        },
        getZonas(place_id) {
            this.loading_zonas = true;

            const params = {
                filters: {
                    place_id: place_id
                }
            };
            this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                this.zonas = res.data;
                this.loading_zonas = false;
            });
        },
        irAZona(paso, zona) {
            this.getZona(zona.id);
        },
        selectZonaTable(paso, zona) {
            this.getZona(zona.id);
            this.zona = zona;
        },
        getZona(id) {
            this.loading_butacas = true;
            const params = {
                filters: {
                    zona_id: id,
                    conf: 0,
                    hidden_seats: 1
                },
            };

            this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                this.zona = res.data;
                this.filas = res.data.configuracion_asientos;
                this.loading_butacas = false;
            });
        },
        getZonaResultado(id) {
            this.loading_resultado = true;
            const params = {
                filters: {
                    zona_id: id,
                    conf: 0
                },
            };

            this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                this.filas_resultado = res.data.configuracion_asientos;
                this.loading_resultado = false;
            });
        },
        toggleSeleccion : function(fila, asiento, anadir, puede_cambiar) {
            const params = {
                filters: {
                    zona_id: this.zona.id,
                    fila: fila,
                    asiento: asiento,
                    mode: this.mode
                },
                zona_id: this.zona.id,
                fila: fila,
                asiento: asiento,
                mode: this.mode
            };

            this.$store.dispatch(this.config.getVuexAlias('zonas.ocultar.butaca'), params).then(res => {
                for(var i in this.filas[fila]) {
                    if(this.filas[fila][i].asiento == asiento) {
                        this.filas[fila][i].oculto = parseInt(res.data.oculta);
                    }
                }

                if(this.zona.ocultos.length == 0) {
                    this.zona.ocultos.push({
                        row: fila,
                        seat: asiento,
                        mode: res.data.oculta,
                        region_id: this.zona.id
                    });
                } else {
                    for (var j in this.zona.ocultos) {
                        if(this.zona.ocultos[j].row == fila && this.zona.ocultos[j].seat == asiento) {
                            if(res.data.oculta == 0) {
                                this.zona.ocultos.splice(j, 1);
                                break;
                            }
                        } else {
                            if(parseInt(res.data.oculta) > 0) {
                                this.zona.ocultos.push({
                                    row: fila,
                                    seat: asiento,
                                    mode: res.data.oculta,
                                    region_id: this.zona.id
                                });
                                break;
                            }
                        }
                    }
                }
            });

        },
    },
    components: {
        CleSvgComponent, AsientoComponent, TerrenoJuegoComponent, TablaSectoresComponent
    }
}
</script>